export const CONTENT_TYPE_BY_EXTENSION: Record<string, string> = {
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  epub: "application/epub+zip",
};

export const MANUSCRIPT_ACCEPT_MAP: Record<string, string[]> =
  Object.fromEntries(
    Object.entries(CONTENT_TYPE_BY_EXTENSION).map(
      ([extension, contentType]) => [contentType, [`.${extension}`]],
    ),
  );

export const getFileExtension = (fileName: string): string => {
  const lastDot = fileName.lastIndexOf(".");
  return lastDot > 0 && lastDot < fileName.length - 1
    ? fileName.slice(lastDot + 1).toLowerCase()
    : "";
};

export const getContentType = (file: File): string =>
  CONTENT_TYPE_BY_EXTENSION[getFileExtension(file.name)] ?? file.type;

const EXTENSION_BY_CONTENT_TYPE: Record<string, string> = Object.fromEntries(
  Object.entries(CONTENT_TYPE_BY_EXTENSION).map(([extension, contentType]) => [
    contentType,
    extension,
  ]),
);

export const getManuscriptExtension = (file: File): string =>
  getFileExtension(file.name) || (EXTENSION_BY_CONTENT_TYPE[file.type] ?? "");
